import React from 'react'
import { Header, Icon, Button } from 'semantic-ui-react'

import '../css/org-detail.css'

export default class MobileOrgDetail extends React.Component {
  render () {
    const { proposal } = this.props
    return (
      <div>
        <Header as='h2'>
          {proposal.projectTitle}
          <Header.Subheader>
            {proposal.organisationName}
            {proposal.selected == '1' && <span> &middot; Selected</span>}
          </Header.Subheader>
        </Header>
        <div>
          <img
            src={proposal.orgDisplayLink}
            alt='proposal-1'
            className='mobile-org-picture'
          />
        </div>
        <div>
          <Header
            as='h3'
            style={{ marginTop: '0.75rem', marginBottom: '0.25rem' }}
          >
            Project description
          </Header>
          {proposal.projectDescription}
        </div>
        <div className='proposal-container proposal-container-mobile'>
          <Button
            color='blue'
            as='a'
            href={proposal.proposalLink}
            target='_blank'
            className='view-proposal-button'
            size='large'
          >
            <Icon name='file pdf outline' />
            View submitted proposal
          </Button>
        </div>
      </div>
    )
  }
}
